"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionClient = exports.getContinuationToken = void 0;
const tslib_1 = require("tslib");
/// <reference lib="esnext.asynciterable" />
var pagingHelper_js_1 = require("./pagingHelper.js");
Object.defineProperty(exports, "getContinuationToken", { enumerable: true, get: function () { return pagingHelper_js_1.getContinuationToken; } });
tslib_1.__exportStar(require("./models/index.js"), exports);
var subscriptionClient_js_1 = require("./subscriptionClient.js");
Object.defineProperty(exports, "SubscriptionClient", { enumerable: true, get: function () { return subscriptionClient_js_1.SubscriptionClient; } });
tslib_1.__exportStar(require("./operationsInterfaces/index.js"), exports);
//# sourceMappingURL=index.js.map